// src/user/services/api/workflows.js

import { apiRequest, buildUrl } from './index';

/**
 * Workflows API service
 * Handles all workflow-related API calls
 */

/**
 * Fetch workflow details by workflow ID (admin/preview mode only)
 * @param {string} workflowId - The workflow ID
 * @param {AbortSignal} [signal] - Optional abort signal
 * @returns {Promise<Object>} Workflow data
 */
export async function fetchWorkflowDetails(workflowId, { signal } = {}) {
  const url = buildUrl(`/v1/workflows/${encodeURIComponent(workflowId)}`);
  return apiRequest(url, { signal });
}
